import {formatCurrencyAmountToMajorUnitsFixed} from 'src/utils/helpers';
import type {SupportedCurrency} from 'src/v2/state/types';
import {formatAssetCode} from 'src/v2/util/formatAssetCode';

import {message, useIntl} from '@sail/intl';

const messages = {
  payText: message<{
    amount: React.ReactNode;
    currency: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.pay_screen.pay_text',
    description: 'Label on the button to pay',
    defaultMessage: 'Pay {amount} {currency}',
  }),

  payWithoutAmountText: message({
    id: 'crypto.payins.v2.pay_screen.pay_without_amount_text',
    description: 'Label on the button to pay when the amount is unavailable',
    defaultMessage: 'Pay',
  }),
};

type Props = {
  assetCode: SupportedCurrency['assetCode'];
} & (
  | {
      fiatAmount: {
        amount: number;
        currency: string;
      };
    }
  | {
      relayAmount: string | null;
    }
);

export const PayButtonText = (props: Props) => {
  const intl = useIntl();

  let payButtonAmount: string | null = null;
  if ('fiatAmount' in props) {
    // Ideally we should use localized amount. Fixed format for now. e.g., 1.00 USDC
    payButtonAmount = formatCurrencyAmountToMajorUnitsFixed(
      props.fiatAmount.amount,
      props.fiatAmount.currency,
    );
  } else {
    payButtonAmount = props.relayAmount;
  }

  if (!payButtonAmount) {
    return intl.formatMessage(messages.payWithoutAmountText);
  }

  return intl.formatMessage(messages.payText, {
    amount: payButtonAmount,
    currency: formatAssetCode(props.assetCode),
  });
};
